import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { Button } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { EnhancedStatementRow } from '../../../../utils/dataEnhancement'
import { notLocked } from '../../../../../../pages/settings/company/budgeting/budgetingScenarios/utils'
import { filtersSelector } from '../../../../../../redux/context/filters/selectors'
import { useModalActions } from '../../ModalContext'

export const RowActionsNameCellRenderer: React.FC<ICellRendererParams<EnhancedStatementRow>> = ({ data }) => {
  const { t } = useTranslation()
  const { budgetingScenario } = useSelector(filtersSelector)
  const { openEdit, openDelete } = useModalActions()
  const isDisabled = !notLocked(budgetingScenario)

  const handleEditClick = () => {
    if (data) {
      openEdit(data)
    }
  }

  const handleDeleteClick = () => {
    if (data) {
      openDelete(data)
    }
  }

  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%' }}>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
      >
        {data?.name}
      </div>
      <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
        <Button
          type="text"
          size="small"
          icon={<EditOutlined />}
          onClick={handleEditClick}
          title={t('global:edit')}
          disabled={isDisabled}
        />
        <Button
          type="text"
          size="small"
          icon={<DeleteOutlined />}
          onClick={handleDeleteClick}
          title={t('global:delete')}
          danger
          disabled={isDisabled}
        />
      </div>
    </div>
  )
}
